import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/global/global';
import { Friend } from 'src/app/models/friend.model';
import { AlertService } from 'src/app/service/alert.service';
import { DisordersTranslationService } from 'src/app/service/disorders-translation.service';
import { ChatService } from 'src/app/service/http-services/chat.service';
import { FriendService } from 'src/app/service/http-services/friend.service';
import { ChatComponent } from '../chat/chat.component';


@Component({
  selector: 'app-chat-with-friends',
  templateUrl: './chat-with-friends.component.html',
  styleUrls: ['./chat-with-friends.component.css']
})
export class ChatWithFriendsComponent implements OnInit {

  friends!: Friend[]

  constructor(
    private httpClient: HttpClient,
    private alertService: AlertService,
    private chatService: ChatService,
    private friendService: FriendService,
    private router: Router,
    private disordersTranslationService: DisordersTranslationService
  ) { }

  ngOnInit(): void {
    this.friendService.getFriendsList().subscribe(message => {
      this.friends = message;
    })
  }

  getTranslatedDisorders(friend: Friend) {
    return this.disordersTranslationService.translateDisordersEnum(friend.disorders);
  }


  findFriend() {
    this.friendService.findFriend().subscribe(message => {
      // this.friends = message
    },
      err => {
        this.alertService.error(err.error.message, { autoClose: true })
      })
  }

  chatWith(friend: Friend) {
    this.chatService.getChatId(friend.id).subscribe(rsp => {
      this.chatService.setChatFriend(friend);
      this.router.navigate(["/chat", rsp])
    })

  }

}
